import type { ResolvedPageMetadata } from './socialMetadata'
import { SITE_METADATA } from './socialMetadata'

function meta(selector: string, attribute: 'name' | 'property', key: string, content: string) {
  let element = document.head.querySelector<HTMLMetaElement>(selector)
  if (!element) {
    element = document.createElement('meta')
    element.setAttribute(attribute, key)
    element.dataset.cendoscarMetadata = 'true'
    document.head.appendChild(element)
  }
  element.content = content
}

export function applyPageMetadata(value: ResolvedPageMetadata) {
  document.title = value.title.includes(SITE_METADATA.siteName) ? value.title : `${value.title} | ${SITE_METADATA.siteName}`
  meta('meta[name="description"]', 'name', 'description', value.description)
  meta('meta[name="robots"]', 'name', 'robots', value.noIndex ? 'noindex,nofollow' : 'index,follow')
  const properties: Record<string, string> = {
    'og:type': value.type, 'og:title': value.title, 'og:description': value.description,
    'og:image': value.imageUrl, 'og:image:alt': value.imageAlt, 'og:url': value.canonicalUrl,
    'og:site_name': SITE_METADATA.siteName, 'og:locale': SITE_METADATA.locale,
  }
  for (const [key, content] of Object.entries(properties)) meta(`meta[property="${key}"]`, 'property', key, content)
  const twitter: Record<string, string> = {
    'twitter:card': 'summary_large_image', 'twitter:title': value.title,
    'twitter:description': value.description, 'twitter:image': value.imageUrl, 'twitter:image:alt': value.imageAlt,
  }
  for (const [key, content] of Object.entries(twitter)) meta(`meta[name="${key}"]`, 'name', key, content)
  let canonical = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]')
  if (!canonical) {
    canonical = document.createElement('link')
    canonical.rel = 'canonical'
    canonical.dataset.cendoscarMetadata = 'true'
    document.head.appendChild(canonical)
  }
  canonical.href = value.canonicalUrl
  document.head.querySelectorAll('[data-cendoscar-article]').forEach((node) => node.remove())
  if (value.type === 'article') {
    if (value.publishedTime) articleMeta('article:published_time', value.publishedTime)
    if (value.modifiedTime) articleMeta('article:modified_time', value.modifiedTime)
  }
}

function articleMeta(property: string, content: string) {
  const element = document.createElement('meta')
  element.setAttribute('property', property)
  element.content = content
  element.dataset.cendoscarArticle = 'true'
  document.head.appendChild(element)
}
